// components/CustomTextField.jsx
import React from 'react';
import { TextField, InputAdornment, IconButton, Tooltip } from '@mui/material';
import PropTypes from 'prop-types';

const CustomTextField = ({
  size = 'small',
  style = {},
  placeholder = 'No registrado',
  type = 'text',
  required = false,
  name,
  label,
  onChange,
  value,
  maxLength = 200,
  startAdornment,
  endAdornment,
  readOnly = false,
  focused = false,
  variant = 'outlined',
  color = 'primary',
  numeric = false,
  helperText = '',
  fullWidth = false,
  icon: IconComponent,
  iconTooltip = '',
  ...props
}) => {
  const handleChange = (e) => {
    if (numeric && e.target.value && !/^[0-9]*$/.test(e.target.value)) {
      return;
    }
    if (onChange) onChange(e);
  };

  const inputProps = {
    maxLength,
    readOnly,
    ...props.inputProps,
  };

  const InputProps = {
    startAdornment: startAdornment ? (
      <InputAdornment position="start">
        {typeof startAdornment === 'string' ? startAdornment : startAdornment}
      </InputAdornment>
    ) : null,
    endAdornment: IconComponent ? (
      <Tooltip title={iconTooltip}>
        <IconButton edge="end">
          <IconComponent />
        </IconButton>
      </Tooltip>
    ) : endAdornment ? (
      <InputAdornment position="end">{endAdornment}</InputAdornment>
    ) : null,
    readOnly,
    ...props.InputProps,
  };

  return (
    <TextField
      size={size}
      style={style}
      placeholder={placeholder}
      type={type}
      required={required}
      name={name}
      label={label}
      onChange={handleChange}
      value={value}
      focused={focused}
      variant={variant}
      color={color}
      fullWidth={fullWidth}
      helperText={helperText}
      inputProps={inputProps}
      InputProps={InputProps}
      onKeyPress={numeric ? (e) => !/[0-9]/.test(e.key) && e.preventDefault() : null}
      {...props}
    />
  );
};

CustomTextField.propTypes = {
  size: PropTypes.oneOf(['small', 'medium']),
  style: PropTypes.object,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  required: PropTypes.bool,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  value: PropTypes.any,
  maxLength: PropTypes.number,
  startAdornment: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  endAdornment: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  readOnly: PropTypes.bool,
  focused: PropTypes.bool,
  variant: PropTypes.oneOf(['outlined', 'filled', 'standard']),
  color: PropTypes.string,
  numeric: PropTypes.bool,
  helperText: PropTypes.string,
  fullWidth: PropTypes.bool,
  icon: PropTypes.elementType,
  iconTooltip: PropTypes.string,
  inputProps: PropTypes.object,
  InputProps: PropTypes.object,
};

export default CustomTextField;